import $ from 'jquery';

function AccordionFix(element) {
  this.$element = $(element);
  this.init();
}

AccordionFix.prototype = {
  init() {
    this.$element.find(':not(.accordion-item) + .accordion-item, * > .accordion-item:first-of-type').each((i, elem) => {
      $(elem)
        .nextUntil(':not(.accordion-item)')
        .addBack()
        .wrapAll('<div class="accordion-wrapper" />');
    });
  },
};

export default AccordionFix;
